import { FaTaxi, FaSmile, FaCalendarAlt, FaMapMarkedAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaTaxi />, // Taxi icon for rides completed
        title: 'Rides Completed',
        count: '100000',
    },
    {
        id: 2,
        icon: <FaSmile />, // Smile icon for happy customers
        title: 'Happy Customers',
        count: '20000',
    },
    {
        id: 3,
        icon: <FaCalendarAlt />, // Calendar icon for years of service
        title: 'Years of Service',
        count: '10',
    },
    {
        id: 4,
        icon: <FaMapMarkedAlt />, // Map marker icon for cities covered
        title: 'Cities Covered',
        count: '30',
    },
];

export default counter;